import axios from 'axios';

const url = `${process.env.REACT_APP_SERVER}passcodes`;

class PassCodesApi {
  resetPassword(email) {
    const bodyRequest = {
      email
    };
    return axios.post(`${url}/reset`, bodyRequest).then((response) => response.data).catch((err) => console.error('err', err));
  }

  changePassword(password, token) {
    const bodyRequest = {
      password
    };
    return axios.post(`${url}/${token}/confirmation`, bodyRequest).then((response) => response.data).catch((err) => console.error('err', err));
  }
}

export const passCodesApi = new PassCodesApi();
